import React, { createContext, useCallback, useContext, useMemo, useState, ReactNode } from 'react';
import { DialogProps } from './types';

interface DialogContextProps {
  dialog: DialogProps | null;
  openDialog: (dialog: DialogProps) => void;
  closeDialog: () => void;
}

const DialogContext = createContext<DialogContextProps>(
  {} as DialogContextProps
);  

export const useDialogs = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialogs must be used within a DialogProvider');
  }
  return context;
};

export const DialogProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [dialog, setDialog] = useState<DialogProps | null>(null);

  const openDialog = useCallback((dialog: DialogProps) => setDialog(dialog), []);
  const closeDialog = useCallback(() => setDialog(null), []);

  const value = useMemo(
    () => ({ dialog, openDialog, closeDialog }),
    [dialog, openDialog, closeDialog]
  );

  return (
    <DialogContext.Provider value={value}>
      {children}
    </DialogContext.Provider>
  );
};
